import { isNil } from 'lodash';
import { Field } from '@shared/data/entity/fields/Field';
import { getAddressText } from './getAddressText';
import { getDateRangeText } from './getDateRangeText';
import { getDateText } from './getDateText';
import { getEmailText } from './getEmailText';
import { getFileText } from './getFileText';
import { getNumberText } from './getNumberText';
import { getPersonText } from './getPersonText';
import { getRelatedCardText } from './getRelatedCardText';
import { getTagText } from './getTagText';
import { getTimerText } from './getTimerText';
import { getTodoText } from './getTodoText';
import { getUrlText } from './getUrlText';

/**
 * A field as one line of text, as its inline variant reads: each type's own text helper, or its
 * display string. Empty for an empty field. Location and signature read their display string here,
 * since their inline text names a person who may not have loaded.
 */
export function getFieldText(field: Field | null): string {
  if (isNil(field) || field.isEmpty) {
    return '';
  }
  switch (field.fieldType) {
    case 'AddressField':
      return getAddressText(field);
    case 'DateField':
      return getDateText(field);
    case 'DateRangeField':
      return getDateRangeText(field);
    case 'EmailField':
      return getEmailText(field);
    case 'FileField':
      return getFileText(field);
    case 'NumberField':
      return getNumberText(field);
    case 'PersonField':
      return getPersonText(field);
    case 'RelatedEntityField':
      return getRelatedCardText(field);
    case 'TagField':
      return getTagText(field);
    case 'TimeTrackerField':
      return getTimerText(field.timerEntries);
    case 'TodoField':
      return getTodoText(field);
    case 'UrlField':
      return getUrlText(field);
    default:
      return field.toDisplayString();
  }
}
